<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAddSystemTasks"
      l-button
      v-permission:function="['systemTasksManger:btn_add']"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="tasksList"
      v-loading="listLoading"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="可完成次数(总次数)">
        <template slot-scope="scope">
          <span>{{ scope.row.count }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">开启</span>
          <span v-if="scope.row.status == 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="success"
            @click="getModifySystemTasks(scope.row)"
            v-permission:function="['systemTasksManger:btn_edit']"
            class="mar"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </d2-container>
</template>
<script>
import { getTasksList } from '@/api/demo/systemTasks/index'
export default {
  name: 'systemTasksManger',
  data () {
    return {
      tasksList: [],
      tableKey: 0,
      total: null,
      listLoading: false,
      systemTasksManger_btn_add: false,
      systemTasksManger_btn_edit: false,
      listQuery: {
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示的大小
      }
    }
  },
  created () {
    this.getTasksList()
  },
  watch: {
    $route (to, from) {
      this.getTasksList()
    }
  },
  methods: {
    getTasksList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      getTasksList(that.listQuery).then(res => {
        that.listLoading = true
        that.tasksList = res.records
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 新增
    getAddSystemTasks () {
      this.$router.push({ path: '/demo/systemTasks/createTask' })
    },
    // 编辑
    getModifySystemTasks (rows) {
      this.$router.push({
        path: './systemTasks/createTask',
        query: {
          id: rows.id
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
